// Module
var code = "<div nlg-portlet> <div nlg-portlet-title> <h4 class=pageTitle> <i class=\"glyphicon glyphicon-th-large\"></i> <span translate>title.manager.healthChecker</span> </h4> </div> <div nlg-portlet-body> <nlg-health-checker></nlg-health-checker> </div> </div> ";
// Exports
module.exports = code;